<template>
    <el-select
        :disabled="disableds"
        v-model="serverIds"
        filterable
        clearable
        :multiple="multiple"
        placeholder="请选择"
        size="small"
        @change="change"
        style="width:400px"
    >
        <el-option
            v-for="item in servers"
            :key="item.server_auto_id"
            :label="item.display_server_name + '（' + item.server_id + '）'"
            :value="item.server_auto_id"
            :disabled="item.disabled"
        >
        </el-option>
    </el-select>
</template>
<script>
export default {
    name: "select-server",
    props: ["servers", "selected", "values", "multiple", "disable"],
    data() {
        return {
            serverIds: [],
            disableds: false
        };
    },
    methods: {
        change() {
            this.selected(this.serverIds);
        }
    },

    watch: {
        disable(val) {
            this.disableds = val;
        }
    },

    mounted() {
        this.serverIds = this.values > 0 ? this.values : "";
        if (this.disable !== undefined) {
            this.disableds = this.disable;
        }
        if (this.serverIds.length > 0) this.selected(this.serverIds);
    }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// website/subComponents/server.vue